import { render, staticRenderFns } from "./MessageContainer.vue?vue&type=template&id=022c1600&scoped=true&"
import script from "./MessageContainer.vue?vue&type=script&lang=js&"
export * from "./MessageContainer.vue?vue&type=script&lang=js&"
import style0 from "./MessageContainer.vue?vue&type=style&index=0&id=022c1600&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022c1600",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VIcon,VOverlay,VProgressCircular})
